import { type ReactNode, type Ref, forwardRef } from 'react';

import styles from './CustomRoundButton.css';

type CustomRoundButtonProps = {
  icon: JSX.Element;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const CustomRoundButton = forwardRef(function CustomRoundButton(
  { icon, ...buttonProps }: CustomRoundButtonProps,
  ref: Ref<HTMLButtonElement>,
): ReactNode {
  return (
    <button {...buttonProps} className={styles['button']} ref={ref}>
      {icon}
    </button>
  );
});
